import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

// Catches WebGL context failures / chunk load errors so a broken experience
// degrades to a friendly card instead of a white screen.
type Props = { children: ReactNode; label: string };
type State = { failed: boolean };

export default class ErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.warn(`[poparium] ${this.props.label} crashed:`, error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.failed) {
      return (
        <div className="boundary-fallback" role="alert">
          <p className="boundary-title">The {this.props.label} took a nap. 😴</p>
          <p>Your browser may not support WebGL — or something just fizzled.</p>
          <button className="cta" onClick={() => location.reload()}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
